import Swal from "sweetalert2";

export const confirmAction = async (
  title = "Are you sure?",
  text = "This action cannot be undone.",
  confirmText = "Yes, proceed"
) => {
  return await Swal.fire({
    title,
    text,
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: confirmText,
    cancelButtonText: "Cancel",
    confirmButtonColor: "#735DFF",
    cancelButtonColor: "#FF4523",
    buttonsStyling: false,
    background: "#FFFFFF",
    zIndex: 20000, 
    color: "#000750",
    customClass: {
      popup: "rounded-xl shadow-xl border border-gray-200",
      title: "text-lg font-semibold",
      confirmButton:
        "px-5 py-2 rounded-lg font-medium bg-primary text-white hover:bg-primary/90 transition-all",
      cancelButton:
        "px-5 py-2 rounded-lg font-medium bg-status-danger text-white hover:bg-red-600 transition-all ml-2",
    },
  });
};

export const toastSuccess = (msg) => {
  Swal.fire({
    title: msg,
    icon: "success",
    timer: 1200,
    showConfirmButton: false,
    iconColor: "#0CC763",
    background: "#FFFFFF",
    zIndex: 20000,
  });
};

export const toastError = (msg) => {
  Swal.fire({
    title: msg,
    icon: "error",
    timer: 1400,
    showConfirmButton: false,
    iconColor: "#FF4523",
    background: "#FFFFFF",
    zIndex: 20000, 
  });
};
